import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/domains';
import { User } from './user';
export var SignInResponse = /*#__PURE__*/function (_ValueObject) {
  _inherits(SignInResponse, _ValueObject);

  var _super = _createSuper(SignInResponse);

  function SignInResponse() {
    _classCallCheck(this, SignInResponse);

    return _super.apply(this, arguments);
  }

  _createClass(SignInResponse, [{
    key: "accessId",
    get: function get() {
      return this.props.accessId;
    }
  }, {
    key: "accessToken",
    get: function get() {
      return this.props.accessToken;
    }
  }, {
    key: "profile",
    get: function get() {
      return this.props.profile;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        accessId: this.accessId,
        accessToken: this.accessToken
      };
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.accessId,
        argumentName: 'Access Id'
      }, {
        argument: props.accessToken,
        argumentName: 'Access Token'
      }, {
        argument: props.profile,
        argumentName: 'Profile'
      }];
      var result = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!result.succeeded) {
        var _result$message;

        return Result.fail((_result$message = result.message) !== null && _result$message !== void 0 ? _result$message : 'Error');
      }

      return Result.ok(new SignInResponse(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      return SignInResponse.create({
        accessId: data.accessId,
        accessToken: data.accessToken,
        profile: User.create(data.profile).getValue()
      });
    }
  }]);

  return SignInResponse;
}(ValueObject);